import { render, staticRenderFns } from "./DesignEditorButtonGroup.vue?vue&type=template&id=46963b51&scoped=true&"
import script from "./DesignEditorButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./DesignEditorButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./DesignEditorButtonGroup.vue?vue&type=style&index=0&id=46963b51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46963b51",
  null
  
)

export default component.exports